<template>
<div class="firstPage">
  <big-screen></big-screen>
  <i class="el-icon-full-screen fullScreen " title="全屏" @click="seeView"></i>
</div>
</template>

<script>
import BigScreen from '@/components/firstPage/BigScreen.vue'
export default {
  components: {
    BigScreen,
  },
  data() {
    return {

    }
  },
  methods: {
    seeView() {
      this.$router.push('/screen')
    },
  },
}
</script>

<style lang="scss" scoped>
.firstPage {
  width: 100%;
  height: 100%;
  position: relative;

  .fullScreen {
    position: absolute;
    top: 25px;
    transform: translateY(-50%);
    right: 20px;
    z-index: 100;
    font-size: 20px;
    color: #fff;
  }
  i{
    cursor: pointer;
  }
}
</style>
